import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import colors from "../../Constants/colors";
import { useTranslation } from "react-i18next";
import { ComoButton } from "../Common/ComoButton";

interface DefaultDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedList: {
    name: string;
    category: { name: string };
  } | null;
}

const DefaultDialog: React.FC<DefaultDialogProps> = ({
  open,
  onClose,
  onConfirm,
  selectedList,
}) => {
  const { t } = useTranslation("myQuestionLists");

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="default-dialog-title"
      aria-describedby="default-dialog-description"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          border: `1px solid ${colors.gray200}`,
        },
      }}
    >
      <DialogTitle
        id="default-dialog-title"
        sx={{ color: colors.primary_dark, fontWeight: 600 }}
      >
        {t("myQuestionLists.dialogs.confirmDefaultTitle")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="default-dialog-description"
          sx={{ color: colors.gray700 }}
        >
          {t("myQuestionLists.dialogs.confirmDefaultMessage", {
            name: selectedList?.name,
            category: selectedList?.category.name,
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <ComoButton onClick={onClose} secondary>
          {t("myQuestionLists.dialogs.defaultCancel")}
        </ComoButton>
        <ComoButton onClick={onConfirm}>
          {t("myQuestionLists.dialogs.defaultConfirm")}
        </ComoButton>
      </DialogActions>
    </Dialog>
  );
};

export default DefaultDialog;
